import AccountingInfoOption from './AccountingInfoOption';

export default class TransactionType extends AccountingInfoOption {
    public static entity = 'transactionTypes';
    public static apiType = 'transaction-types';
    public static storageKey = 'transaction_types_list';
}